<template>
  <div style="store-page">

    <el-breadcrumb style="margin-bottom:30px; margin-top:25px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="first-breadcrumb" :to="{ path: $route.path.indexOf('SPU') != -1 ? '/SPU/Seller/' + $route.params.Id : '/Seller/' + $route.params.Id }">{{ $t("DashboardProduct.tablinkseller") }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('dsfx.t13')}}</el-breadcrumb-item>
    </el-breadcrumb>
    
    <SellerDetail />

  </div>
</template>

<script>
import SellerDetail from '@/components/Seller/SellerDetail.vue'
export default {
  components:{
    SellerDetail
  },
  data(){
    return{
      routerparams: {
        Id: this.$route.params.Id,
        ShopId: this.$route.params.Sid
      }
    }
  },

  mounted(){
    
  },

}
</script>